module.exports = __webpack_public_path__ + "media/5-star-wish-reveal.9edcdcc3.mp3";